import { connect } from 'react-redux';
import { IAppState } from '../../../../common/state';
import { getDeveloperPresenter, getIsLeadFactory } from '../../../../selectors';
import { BusinessCard, IBusinessCardProps } from './BusinessCard';

export function mapStateToProps(state: IAppState): IBusinessCardProps {
  const { newbuildingInfo } = state.results;

  return {
    developer: newbuildingInfo && newbuildingInfo.developer,
    isLeadFactory: getIsLeadFactory(state),
    developerPresenter: getDeveloperPresenter(state),
  };
}

const BusinessCardContainer = connect(mapStateToProps)(BusinessCard);

// tslint:disable-next-line:no-default-export
export default BusinessCardContainer;
